import moment from "moment";
import * as momentTz from "moment-timezone";

/**
 *
 * @param {*} list
 * @param {*} columnSettings
 * @returns
 */
export const columnsOrdering = (list, columnSettings) => {
	let columns = [...list];
	columnSettings = columnSettings.filter(
		(columnSetting) => columnSetting.status
	);

	const swapArray = (array, from, to) => {
		let temp = array[from];
		array[from] = array[to];
		array[to] = temp;
		return array;
	};

	const moveArray = (items) => {
		for (let i = 0; i < items.length; i++) {
			const index = columnSettings.findIndex(
				(columnSetting) => columnSetting.label === items[i].label
			);
			if (index !== -1) {
				if (i - 1 !== index) {
					columns = swapArray(columns, i, index + 1);
					moveArray(columns);
				}
			}
			if (i === items.length - 1) return columns;
		}
	};

	return moveArray(columns);
};

/**
 *
 * @param {*} date
 * @param {*} time
 * @returns
 */
export const getCurrentTimezoneDate = (date, time = false) => {
	let _timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
	return time
		? momentTz.tz(date, _timeZone).format("MM/DD/YYYY hh:mmA")
		: momentTz.tz(date, _timeZone).format("MM/DD/YYYY");
	// let _timeZone = "US/Pacific";
	// return momentTz.tz(date, _timeZone).format("MM-DD-YYYY hh:mmA");
};

/**
 * @param {*} data
 * @returns date with time zone
 */
export const getCurrentTimezoneDateFilter = (date) => {
	let _timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
	return momentTz.tz(date, _timeZone).format("MM-DD-YYYY");
	// let _timeZone = "US/Pacific";
	// return momentTz.tz(date, _timeZone).format("YYYY-MM-DD");
};

/**
 *
 * @param {*} date
 * @returns
 */
export const getFilterDate = (date) => {
	return moment(date).format();
	// return new Date(date).toISOString().toLocaleString("en-US", {
	//   timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
	// });
};
